<template>
  <button ref="button" type="button" class="btn mb-0" :class="`${getClasses(variant, color, size, fullWidth, active)}`"
    @click="handleClick" :disabled="loading">
    <span v-if="loading" v-show="loading" class="loading" :style="{ width: nameWidth + 'px' }">
      <i class="spinner"></i>
    </span>
    <span v-else v-show="!loading" class="name" ref="nameRef">
      <slot />
    </span>
  </button>
</template>

<!-- <template>
  <button class="btn mb-0" :class="getClasses(variant, color, size, fullWidth, active)">
    <slot />
  </button>
</template> -->

<script>
export default {
  name: "VsudButton",
  data() {
    return {
      nameWidth: 0,
    }
  },
  props: {
    color: {
      type: String,
      default: "info",
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      required: true,
    },
    load: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    window.addEventListener("click", this.handleClickOutside);
    this.saveNameWidth();
  },
  beforeUnmount() {
    window.removeEventListener("load", this.onLoad);
    window.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    loading() {
      return this.load;
    },
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active) => {
      let colorValue, sizeValue, fullWidthValue, activeValue;

      // Setting the button variant and color
      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else if (variant === "outline") {
        colorValue = `btn-outline-${color}`;
      } else {
        colorValue = `btn-${color}`;
      }

      sizeValue = size ? `btn-${size}` : null;

      fullWidthValue = fullWidth ? `w-100` : null;

      activeValue = active ? `active` : null;

      return `${colorValue} ${sizeValue} ${fullWidthValue} ${activeValue}`;
    },
    saveNameWidth() {
      const nameElement = this.$refs.nameRef;
      if (nameElement) {
        this.nameWidth = nameElement.offsetWidth;
      }
    },
    handleClick(event) {
      event.stopPropagation();
      if (typeof this.onClick === 'function') {
        this.$emit("update:load", true);
        this.saveNameWidth();
        setTimeout(() => {
          this.onClick();
          this.$emit("update:load", true);
        }, 500);
      } else {
        this.$emit("update:load", false);
      }
    },
    handleClickOutside(event) {
      if (this.$refs.button && !this.$refs.button.contains(event.target)) {
        this.$emit("update:load", false);
      }
    },
  },
};
</script>

<style scoped>
button {
  border-radius: 12px;
  font-weight: 400;
  text-transform: none;
  letter-spacing: +0.02rem;
  background-color: var(--blue);
}

button:hover {
  background-color: var(--blue-hover);
}

.spinner {
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-left: 3px solid var(--background);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  width: 14px;
  height: 14px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

button.btn {
  display: flex;
  justify-content: center;
  align-content: center;
}

span.loading {
  margin: auto;
  text-align: center !important;
}

.btn-check:focus + .btn-info, .btn-info:focus {
  background-color: var(--blue);
}
.btn-outline-secondary{
  border: 1px solid var(--light-gray) !important;
  border-radius: 12px !important;
  min-width: 38.4px!important;
  background-color: var(--background)!important;
}
</style>